"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RESERVED_FACTOR_NAMES", {
    enumerable: true,
    get: function() {
        return RESERVED_FACTOR_NAMES;
    }
});
const _factorsjson = /*#__PURE__*/ _interop_require_default(require("./factors.json"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Additional reserved names not in factors.json
// - eNPS: The Net Promoter Score question factor
// - Custom: Reserved for custom factor questions
// - Other: Reserved for open-ended/additional feedback questions
const ADDITIONAL_RESERVED_NAMES = [
    "eNPS",
    "Custom",
    "Other"
];
const RESERVED_FACTOR_NAMES = [
    ..._factorsjson.default.map((f)=>f.name),
    ...ADDITIONAL_RESERVED_NAMES
];
